export function formatBRL(value){
  try {
    value = parseFloat(value).toFixed(2);
    let is_negative = false;
    if(value.indexOf("-") !== -1){
      is_negative = true;
      value = value.replace("-","");
    }
    const [v1, v2] = value.split('.');
    let res = "";

    for (let i = 0; i < v1.length; i++){
      let j = (v1.length-1)-i;
      let c = v1[j];
      if(i%3 === 0 && i !== 0){
        res = "."+res;
      }
      res = c+res;
    }

    return `${(is_negative?"-":"")}R$ ${res},${v2}`;
  } catch (error) {
    return value;
  }
}

export function formatDateBR(value){
  try {
    let [date] = value.split(' ');
    let [Y,M,D] = date.split('-');
    return `${D}/${M}/${Y}`
  } catch (error) {
    return null;
  }
}

export function formatDate(value){
  try {
    let [date, hours] = value.split(' ');
    return new Date(date);
  } catch (error) {
    return "---";
  }
}

export function formatDocument(value){
  let r = "XX.XXX.XXX/XXXX-XX"
  for (let i = 0; i < value.length; i++) {
    r = r.replace("X",value[i]) ;
  }
  return r;
}